import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { OrderContext } from 'graphql/libs/shopping-cart-front/src/graphql';
import { ParseJson } from 'ZalamoLibrary/src/lib/core/decorators/ParseJson';
import { buildSessionStatsParsedDetails } from './session-stats.helpers';
import {
  ParsedDetails,
  SessionStatsDetails,
  TopPublicSessionOrganizationGroupDetailsItem,
} from './session-stats.model';

@Component({
    selector: 'app-session-stats',
    templateUrl: './session-stats.component.html',
    styleUrls: ['./session-stats.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SessionStatsComponent {
  readonly orderContext = OrderContext;
  detailsPayload: SessionStatsDetails | null = null;
  parsedDetails: ParsedDetails | null = null;

  @Input()
  @ParseJson
  set details(details: SessionStatsDetails | null | undefined) {
    this.detailsPayload = details ?? null;
    this.parsedDetails = buildSessionStatsParsedDetails(details);
  }

  trackBySessionId(
    _index: number,
    session: { id: string; context?: OrderContext },
  ): string {
    return `${session.context ?? 'session'}:${session.id}`;
  }

  trackById(_index: number, item: { id: string }): string {
    return item.id;
  }

  trackByPublicSessionOrganizationGroupId(
    _index: number,
    item: TopPublicSessionOrganizationGroupDetailsItem,
  ): string {
    return `${item.publicSessionOrganizationId}:${item.id}`;
  }
}
